module.exports = __webpack_public_path__ + "static/media/hit-boss.2ea62638.mp3";